export enum LocationType {
	Origin = 0,
	Destination = 1,
}
